export const uppercaseFirst = string => string.charAt(0).toUpperCase() + string.slice(1);

export const convertCamelCaseToSentenceCase = camelCase =>
    camelCase.replace(/([A-Z])/g, ' $1').toLowerCase();
